import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-search-box" }
const _hoisted_2 = { class: "user-search-box__search-bar" }

import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Button as kButton } from '@progress/kendo-vue-buttons';
import TextBox from '@/components/common/textBox/TextBox.vue';
import { useAppStore } from '@/stores/app.store';
import useTranslations from '@/composables/useTranslations';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserSearchBox',
  emits: ["search-clicked"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { translate: t } = useTranslations();
const router = useRouter();
const route = useRoute();
const appStore = useAppStore();

const userSearchBoxInputRef = ref();
const searchPhrase = ref('');

const isInputValid = computed(() => searchPhrase.value.trim().length > 0);

async function handleSearchBtnClick() {
  if (isInputValid.value) {
    emit('search-clicked');
    await search();
  }
}

async function search() {
  await router.push({ name: 'SearchResults', query: { searchPhrase: searchPhrase.value } });
}

onMounted(() => {
  if (!appStore.isMobile) userSearchBoxInputRef.value?.focus?.();
  if (route?.query?.searchPhrase && route?.query?.searchPhrase?.length > 0) {
    searchPhrase.value = route?.query?.searchPhrase as string;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TextBox, {
        id: "user-search-box__input",
        ref_key: "userSearchBoxInputRef",
        ref: userSearchBoxInputRef,
        modelValue: searchPhrase.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchPhrase).value = $event)),
        "fill-mode": undefined,
        "input-suffix": 'suffix',
        placeholder: _unref(t)('Search'),
        "show-clear-button": true,
        onKeyup: [
          _withKeys(handleSearchBtnClick, ["enter"]),
          _withKeys(handleSearchBtnClick, ["esc"])
        ]
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    _createVNode(_unref(kButton), {
      class: "user-search-box__search-button",
      disabled: !isInputValid.value,
      "fill-mode": 'flat',
      "icon-class": 
        _unref(appStore)?.isMobile
          ? 'cwx-icon cwx-icon-before_zoom'
          : 'cwx-icon cwx-icon-before_arrow-chevron-right'
      ,
      size: 'large',
      shape: 'square',
      onClick: handleSearchBtnClick
    }, null, 8, ["disabled", "icon-class"])
  ]))
}
}

})